import { EventEmitter, Injectable } from '@angular/core';
import { Widget } from '../../models/widget';
import { WidgetService } from '../widget.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class WidgetDetailInstanceService {
  widget: Widget;
  $widget: BehaviorSubject<Widget> = new BehaviorSubject<Widget>(null);
  $error: EventEmitter<any> = new EventEmitter<any>();

  constructor(private widgetService: WidgetService) {
  }

  loadWidget(id: number) {
    this.widgetService.getWidget(id)
      .subscribe((widget: Widget) => {
        this.widget = widget;
        this.$widget.next(widget);
      }, err => {
        this.$error.next(err);
      });
  }

  reload() {
    this.loadWidget(this.widget.id);
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/widget-detail/widget-detail-instance.service.ts